// @flow

import { AxiosResponse } from "axios";
import { saveAs } from "file-saver";

export const saveFile = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(new Blob([blob]));

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${filename}`);
  document.body?.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(url);
};

export function parseContentDispositionFilename(header: string | typeof undefined): string | null {
  const match = header?.match(/filename\*\s*=\s*([^;]+)/i);
  if (!match) return null;

  let value = match[1].trim();

  if (value.startsWith('"') && value.endsWith('"')) {
    value = value.slice(1, -1);
  }

  const encodingSplit = value.split("''");
  if (encodingSplit.length !== 2) return null;
  let filename = encodingSplit[1];

  const bytes = Uint8Array.from([...filename].map(c => c.charCodeAt(0)));
  filename = new TextDecoder("utf-8").decode(bytes);

  return filename;
}

export const extractFilenameFromResponse = (
  response: AxiosResponse<AxiosResponse<any, any>, any>,
  fallbackName: string | typeof undefined
) => {
  const contentDisposition = response.headers["content-disposition"];
  const filename = parseContentDispositionFilename(contentDisposition);
  return filename || fallbackName;
};

export const saveFileFromResponse = (
  response: AxiosResponse<AxiosResponse<any, any>, any>,
  fallbackName: string | typeof undefined
) => {
  const contentType = response.headers["content-type"];
  const filename = extractFilenameFromResponse(response, fallbackName);

  const blob = new Blob([response.data], { type: contentType });
  saveAs(blob, filename);
};
